import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class DataFilterService {
  filterValueChanged$ = new Subject<[string, any]>();
  refreshFilters$ = new BehaviorSubject<(number | string) | 'ALL'>(null);
}
